module.exports = require("@swa-ui/theme");